export const CHANGE_MODAL = "CHANGE_MODAL"
export const CLOSE_MODAL = "CLOSE_MODAL"